(function () {
    console.log("packsize.js is ready");
  
    function updatePackPricing(variant, product) {
      if (!variant || !product) return;
  
      // 1) Find index of option that contains "pack"
      const optNames =
        product.options ||
        (product.optionsWithValues && product.optionsWithValues.map((o) => o.name)) ||
        [];
  
      const packIdx = optNames.findIndex((name) =>
        name.toLowerCase().includes("pack")
      );
      if (packIdx < 0) return;
  
      function normalize(val) {
        return val.toLowerCase().replace(/[^a-z0-9]/g, "");
      }
  
      // 2) Check if all non-pack options match
      function sameOtherOptions(v) {
        return v.options.every((val, idx) => {
          return idx === packIdx || val === variant.options[idx];
        });
      }
  
      // 3) Find 1-pack variant for same other options
      const baselineVariant = product.variants.find(
        (v) =>
          sameOtherOptions(v) &&
          normalize(v.options[packIdx]) === "1pack"
      );
      const baselinePrice = baselineVariant ? baselineVariant.price : 0;
  
      // 4) Loop through each pack button
      document.querySelectorAll(".option-selector__btns__ps").forEach((el) => {
        const input = el.querySelector("input.js-option");
        if (!input) return;
  
        const rawVal = input.value;
        const count = parseInt(rawVal, 10) || 0;
  
        const match = product.variants.find(
          (v) =>
            sameOtherOptions(v) &&
            normalize(v.options[packIdx]) === normalize(rawVal)
        );
  
        // 5) Per-unit price (for display only)
        const perUnit = match && count ? Math.floor(match.price / count) : 0;
  
        // 6) Percentage saved - FIXED to match theme's calculation
        let percentText = "";
        if (baselinePrice && match && count > 1) {
          // Compare total pack price vs (baseline × count)
          // Formula: (1 - (packPrice / (baseline × count))) × 100
          const baselineTotal = baselinePrice * count;
          const amount = 1.0 - (match.price / baselineTotal);
          const pct = Math.round(amount * 100);
          if (pct > 0) percentText = pct + "%";
        }
  
        console.log("Percent text " + percentText);
  
        // 7) Format money
        const fmtMoney = function (cents) {
          return theme.Shopify.formatMoney(cents, theme.money_format);
        };
  
        // 8) Update DOM
        const qtyLabel = el.querySelector(".ps--qty--label");
        const percentLabel = el.querySelector(".ps--percent--label strong");
        const percentWrap = el.querySelector(".hygge-pack-size__percent");
        if (qtyLabel) {
          qtyLabel.textContent = perUnit ? fmtMoney(perUnit) : "";
        }
        if (percentLabel) {
          percentLabel.textContent = percentText || "";
        }
        if (percentWrap) {
          percentWrap.hidden = !percentText;
        }
      });
    }
  
    // Listen for custom variantChanged event
    document.addEventListener("variantChanged", function (evt) {
      const detail = evt.target.closest(".product-detail");
      if (!detail) return;
      const variant = evt.detail?.[0];
      const product = evt.detail?.[1];
      if (variant && product) {
        updatePackPricing(variant, product);
      }
    });
  
    // Listen for option click/change
    document.addEventListener("click", handleOptionEvent);
    document.addEventListener("change", handleOptionEvent);
  
    function handleOptionEvent(evt) {
      const el = evt.target.closest(".js-option");
      if (!el) return;
      const form = el.closest(".product-detail");
      const pd = form && form.dataset && form.dataset.product
        ? JSON.parse(form.dataset.product)
        : null;
      if (pd?.selected_variant) updatePackPricing(pd.selected_variant, pd);
    }
  
    // Initial run on DOM ready
    document.addEventListener("DOMContentLoaded", function () {
      const form = document.querySelector(".product-detail");
      const pd = form && form.dataset && form.dataset.product
        ? JSON.parse(form.dataset.product)
        : null;
      if (pd?.selected_variant) updatePackPricing(pd.selected_variant, pd);
    });
  })();